<template>
  <div class="data-list">
    <div class="data-list-header">
      <search-box class="search-box">
        <el-form :inline="true" :model="searchForm" ref="searchForm" label-width="110px" size="mini">
          <el-form-item label="活动id" prop="activityId">
            <el-input v-model="searchForm.activityId" clearable type="number" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="活动名称" prop="activityName">
            <el-input v-model="searchForm.activityName" clearable placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="客户名称" prop="userName">
            <el-input v-model="searchForm.userName" clearable placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="参与时间" prop="updatedTime">
            <q-date-picker v-model="searchForm" ref="dateRef" />
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button size="small" type="primary" @click="onSearch">查询</el-button>
          <el-button size="small" @click="resetSearchForm">重置</el-button>
        </template>
      </search-box>
      <el-row :gutter="20">
        <el-col :span="6">
          <el-card :body-style="{ padding: '0' }">
            <div class="header">活动数量</div>
            <div class="number">{{ textForm.activityCount || 0 }}</div>
          </el-card>
        </el-col>
        <el-col :span="6">
          <el-card :body-style="{ padding: '0' }">
            <div class="header">报名数</div>
            <div class="number">{{ textForm.joinUserCount || 0 }}</div>
          </el-card>
        </el-col>
        <el-col :span="6">
          <el-card :body-style="{ padding: '0' }">
            <div class="header">报名金额</div>
            <div class="number">{{ textForm.signUpAmount || 0 }}</div>
          </el-card>
        </el-col>
        <el-col :span="6">
          <el-card :body-style="{ padding: '0' }">
            <div class="header">退款金额</div>
            <div class="number">{{ textForm.refundAmount || 0 }}</div>
          </el-card>
        </el-col>
      </el-row>
    </div>
    <content-panel>
      <table-panel ref="tablePanel">
        <template v-slot:header-left>
          <el-button type="primary" size="small" @click="exportList">导出</el-button>
        </template>
        <el-table stripe v-loading="loading" ref="tableRef" border highlight-current-row :data="tableData" :height="maxTableHeight">
          <el-table-column prop="activityId" label="活动id" align="center" width="80"></el-table-column>
          <el-table-column prop="activityName" label="活动名称" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="joinUserName" label="用户姓名" align="center" width="130"></el-table-column>
          <el-table-column prop="userPhone" label="联系方式" align="center" width="120"></el-table-column>
          <el-table-column prop="createdTime" label="参与时间" align="center" width="160"></el-table-column>
          <el-table-column prop="joinActivityAmount" label="金额(元)" align="center" width="120"></el-table-column>
          <el-table-column prop="signupStatusString" label="状态" align="center" width="80"></el-table-column>
          <el-table-column prop="storeName" label="分享门店" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="staffName" label="分享职员" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="verificationStoreName" label="核销门店" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="verificationStaffName" label="核销职员" align="center" show-overflow-tooltip></el-table-column>
        </el-table>
        <template v-slot:footer>
          <div style="text-align: right">
            <el-pagination
              @size-change="onSizeChange"
              @current-change="onNumChange"
              :current-page="pageNum"
              :page-size="pageSize"
              :total="total"
              :page-sizes="[20, 50, 100, 200]"
              layout="total, sizes, prev, pager, next, jumper"
            >
            </el-pagination>
          </div>
        </template>
      </table-panel>
    </content-panel>
  </div>
</template>

<script>
import tableMixin from "@/utils/tableMixin";
export default {
  name: "signupData",
  mixins: [tableMixin],
  data() {
    return {
      searchForm: {
        activityId: "",
        activityName: "",
        userName: "",
        startTime: "",
        endTime: "",
      },
      // 表格相关
      tableData: [],
      pageSize: 20,
      pageNum: 1,
      total: 0,
      filterParam: {},
      textForm: {},
      loading: false,
    };
  },
  methods: {
    init() {
      this.onSearch();
      this.activitySignUpStatsInfo();
    },
    activitySignUpStatsInfo() {
      const params = {
        ...this.filterParam,
      };
      this.$api.ActivityManagement.activitySignUpStatsInfo(params).then((res) => {
        this.textForm = res.data;
      });
    },
    getList() {
      this.loading = true;
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        filterData: {
          ...this.filterParam,
        },
      };
      this.$api.ActivityManagement.activitySignUpInfo(params)
        .then(({ data: { list, total } }) => {
          this.tableData = list || [];
          this.total = total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onSizeChange(pageSize) {
      this.pageSize = pageSize;
      // 切换每页条数后从第一页查询
      this.pageNum = 1;
      this.getList();
    },
    onNumChange(pageNum) {
      this.pageNum = pageNum;
      this.getList();
    },
    resetSearchForm() {
      this.$refs.searchForm.resetFields();
      this.initDate()
      this.filterParam = {};
      this.onSearch();
    },
    onSearch() {
      // 每次搜索都初始化搜索条件，重新添加合法的条件
      this.filterParam = {};
      for (const [key, val] of Object.entries(this.searchForm)) {
        if (typeof val !== "undefined" && val !== null && val !== "") {
          this.filterParam[key] = val;
        }
      }
      this.pageNum = 1;
      this.getList();
      this.activitySignUpStatsInfo();
    },
    initDate() {
      this.searchForm.startTime = ''
      this.searchForm.endTime = ''
      this.$refs.dateRef.reset()
    },
    exportList() {
      let params = {
        ...this.filterParam,
      };
      this.$api.common.doExport("activitySignUpInfo", params).then(() => {
        this.$message.success("导出操作成功，请前往导出记录查看详情");
      });
    },
  },
  filters: {},
  mounted() {
    this.init();
  },
};
</script>
<style lang="stylus" scoped>
.date-input {
  width 220px !important
}
.data-list-header {
    margin: 6px 16px;
    .header {
      color: #ccc;
      text-align: center;
      padding: 6px 0;
      border-bottom: 1px solid #ccc;
    }
    .number {
        text-align: center;
        padding: 6px 0;
    }
  }

>>> .search-box {
  padding: 0 20px
  padding-top: 4px;
}
</style>
